import * as marietta from '../../../';
import { beamType } from './AddRoom2D';

/**
 * 2D 梁追加
 * */
export class AddBeam2D {

    constructor(private obj: beamType[], private floor: number) {
        ;
    }

    public execute() {
        const infos = []
        if (this.obj.length == 0) return;
        for (let i = 0; i < this.obj.length; i++) {
            const beamData: any = {};
            beamData.index = 0;
            beamData.id = 'bem01_01';
            beamData.f = this.floor;
            beamData.height = this.obj[i].height;
            beamData.shape = this.obj[i].shape;

            infos.push(beamData);
        }

        marietta.webcad.util.WebcadJSONParser.reproduceBeamItem(infos);
    }

}